import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbService {
    private breadcrumbSource = new BehaviorSubject<Array<string>>([]);
    currentBreadcrumbs = this.breadcrumbSource.asObservable();

    updateBreadcrumbs(breadcrumbs: Array<string>) {
        this.breadcrumbSource.next(breadcrumbs);
    }
}
